import { Badge } from "@/components/ui/badge";
import { ShieldCheck, ShieldAlert, Wrench } from "lucide-react";
import { useLang } from "@/context/LangContext";

export function StatusBadge({ status, governance }) {
  const { tStatus } = useLang();
  const s = governance === "REGULARIZABLE" ? "REGULARIZABLE" : status;
  const map = {
    VERIFIED: { cls: "bg-[#00FF66]/10 text-[#00FF66] border-[#00FF66]/50", Icon: ShieldCheck },
    NOT_VERIFIED: { cls: "bg-[#FF2A2A]/10 text-[#FF2A2A] border-[#FF2A2A]/50", Icon: ShieldAlert },
    REGULARIZABLE: { cls: "bg-[#FFD700]/10 text-[#FFD700] border-[#FFD700]/50", Icon: Wrench },
  };
  const cfg = map[s] || map.NOT_VERIFIED;
  const Icon = cfg.Icon;
  return (
    <Badge
      data-testid={`status-badge-${s}`}
      className={`rounded-none font-mono text-[10px] tracking-wider gap-1.5 px-2 py-1 ${cfg.cls}`}
      variant="outline"
    >
      <Icon className="w-3 h-3" /> {tStatus(s)}
    </Badge>
  );
}
